/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */

/**
 * Class for fixing errored save states
 */
export class SaveStateFixer {
  /**
     * constructor
     */
  constructor() {
    this._starsPerLevel = 3;
    this._lives = 5;
  }

  /**
     * fix a save data Object
     * @param {Object} saveData save data Object
     * @param {number} levelsCompleted # of levels completed
     * @param {*} reason reason??
     */
  fixSaveData(saveData, levelsCompleted, reason, overrideLevels = false) {
    const grantedStars = levelsCompleted * this._starsPerLevel;
    saveData.lives = this._lives;
    this._unlockGates(saveData, levelsCompleted, overrideLevels);
    this._openMapChests(saveData, levelsCompleted, grantedStars);
    this._completeTutorials(saveData, levelsCompleted, overrideLevels);
    this._unlockLevels(saveData, levelsCompleted, this._starsPerLevel, overrideLevels);
  }

  /**
     * unlock gates up to the specified level
     * @param {Object} saveData save data Object
     * @param {number} levelsCompleted # of levels completed
     */
  _unlockGates(saveData, levelsCompleted, overrideGates = false) {
    G.json['configs/gates'].forEach((gateSettings, gateIndex) => {
      if (gateSettings.lvlNr <= levelsCompleted) {
        saveData.gates[gateIndex + 1] = {
          open: true,
          timerStartedAt: 0,
          invites: 0,
        };
      } else if (overrideGates) {
        saveData.gates[gateIndex + 1] = {
          open: false,
          timerStartedAt: 0,
          invites: 0,
        };
      }
    });
  }

  /**
     * open map chests up to the specified level
     * @param {Object} saveData save data Object
     * @param {number} levelsCompleted # of levels completed
     * @param {number} grantedStars # of stars granted
     */
  _openMapChests(saveData, levelsCompleted, grantedStars) {
    const gate = G.Helpers.gatesMgr.getFirstClosedGateData(); // Grab gate?
    if (gate) {
      G.saveState.mapChestDataManager.generateNewChestsToNewGate(gate.id - 1, G.Helpers.levelDataMgr.getTilemapHeight());
    }
    // Otherwise no chest for you!
  }

  /**
     * check if chests are below the specified level index
     * @param {Object} mapChestSettings chest settings Object
     * @param {number} levelIndex index # of highest level reached
     */
  _isChestBelowLevel(mapChestSettings, levelIndex) {
    const levelPosition = G.Helpers.levelDataMgr.getMapPosition(levelIndex);
    return -mapChestSettings.mapY < -levelPosition.y;
  }

  /**
     * mark tutorials as completed
     * @param {Object} saveData save data Object
     * @param {number} levelsCompleted # of levels completed
     */
  _completeTutorials(saveData, levelsCompleted, overrideTutorials = false) {
    if (overrideTutorials) saveData.finishedTutorials = [];
    for (let i = 0; i < levelsCompleted; i++) {
      const levelData = G.Helpers.levelDataMgr.getLevelByIndex(i);
      if (levelData && levelData.tutID) {
        G.StorageUtils.addUnique(saveData.finishedTutorials, levelData.tutID);
      }
    }
  }

  /**
     * unlock levels up to levelCompleted #
     * @param {Object} saveData save data Object
     * @param {number} levelsCompleted # of levels completed
     * @param {number} starsPerLevel stars to unlock
     */
  _unlockLevels(saveData, levelsCompleted, starsPerLevel, overrideCurrent = false) {
    if (overrideCurrent) saveData.levels = [];
    for (let i = 0; i < levelsCompleted; ++i) {
      saveData.levels[i] = starsPerLevel;
    }
  }
}
